(function () {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, "0");
  }

  function updateCountdown(root) {
    var targetValue = root.getAttribute("data-dlx-target");
    var target = targetValue ? new Date(targetValue).getTime() : 0;
    var now = Date.now();
    var distance = Math.max(0, target - now);
    var seconds = Math.floor(distance / 1000);
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = seconds % 60;

    root.querySelector("[data-dlx-days]").textContent = pad(days);
    root.querySelector("[data-dlx-hours]").textContent = pad(hours);
    root.querySelector("[data-dlx-minutes]").textContent = pad(minutes);
    root.querySelector("[data-dlx-seconds]").textContent = pad(remainingSeconds);
  }

  function boot() {
    var countdowns = document.querySelectorAll("[data-dlx-countdown]:not([data-dlx-mounted])");
    countdowns.forEach(function (root) {
      root.setAttribute("data-dlx-mounted", "true");
      updateCountdown(root);
      window.setInterval(function () {
        updateCountdown(root);
      }, 1000);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
